import { SectionDTO } from '../../types/types'
import { SectionState } from './state'

export enum ActionType {
  SET_SECTION_ORDER,
  SAVE_SECTION,
  SET_SECTIONS,
  CREATE_COLLABORATION_ENTITY,
  DELETE_COLLABORATION_ENTITY,
  CREATE_INFO_ENTITY,
  DELETE_INFO_ENTITY,
  CREATE_TARIF_ENTITY,
  DELETE_TARIF_ENTITY,
  CREATE_FAQ_ENTITY,
  DELETE_FAQ_ENTITY,
  CREATE_BENEFITS_ENTITY,
  DELETE_BENEFITS_ENTITY,
  CREATE_COLLABORATION_VIDEO,
  DELETE_COLLABORATION_VIDEO,
  CREATE_INFO_VIDEO,
  DELETE_INFO_VIDEO,
  CREATE_TARIF_VIDEO,
  DELETE_TARIF_VIDEO,
  CREATE_FAQ_VIDEO,
  DELETE_FAQ_VIDEO,
  SET_IS_CHANGES_UPDATING_BLOCKED,
}

export interface SET_SECTION_ORDER {
  type: ActionType.SET_SECTION_ORDER
  payload: {
    oldIndex: number
    newIndex: number
  }
}

export interface SAVE_SECTION {
  type: ActionType.SAVE_SECTION
  payload: {
    section: SectionState
  }
}

export interface SET_SECTIONS {
  type: ActionType.SET_SECTIONS
  payload: {
    sections: SectionDTO[]
  }
}

export interface SET_IS_CHANGES_UPDATING_BLOCKED {
  type: ActionType.SET_IS_CHANGES_UPDATING_BLOCKED
}

export type PromoPageActions = SET_SECTION_ORDER | SAVE_SECTION | SET_SECTIONS | SET_IS_CHANGES_UPDATING_BLOCKED
